import _get from 'lodash/get';
// 是否是容器组件
export const isContainer = ({ name }) => !_get(window, `ARES_COMPONENTS.[${name}].default.isBrick`);
// 是否是积木组件
export const isBrick = ({ name }) => !isContainer({ name });
// 获取组件模块
export function getComponentModule(compName) {
  const compMap = window.ARES_COMPONENTS;
  return _get(compMap, `[${compName}].default`);
}
// 获取组件表单描述config
export function getComponentConfig(compName) {
  const compMap = window.ARES_CONFIGS;
  return _get(compMap, `[${compName}].default.config`) || [];
}
// 获取组件初始化样式
export function getComponentInitialStyle(compName) {
  const compMap = window.ARES_CONFIGS;
  return _get(compMap, `[${compName}].default.style`) || {};
}

// 组件附件类型
export const ComponentAttachmentType = {
  ComponentAttachmentTypeUnknown: 0,
  ComponentAttachmentTypeURL: 1,  // 构建物 CDN 资源地址
  ComponentAttachmentTypeYAML: 2, // YAML 类型文本
};
// 平台
export const Platform = {
  PlatformCMS: 'cms',     // CMS
  PlatformH5: 'h5',      // H5
  PlatformH5React: 'h5_react', // H5 React 版本
  PlatformMP: 'mp',      // 小程序
  PlatformIOS: 'ios',     // IOS 客户端
  PlatformAndroid: 'android', // Android 客户端
};
// 组件类型
export const ComponentType =  {
  ComponentTypeUnknown: 0,
  ComponentTypeCommon: 1,  // 普通编译组件
  ComponentTypeCompose: 2, // YAML 复合组件
};

